export default "__VITE_ASSET__064759e5__"